import { MutationTree } from 'vuex';
import { State } from '@/manager/payment/store/state';
import { Bank } from '@/manager/payment/models/bank.model';

export interface Mutations {
    setBankList: {list: Bank[]};
}

export const mutations: MutationTree<State> = {
    setBankList: (state, payload) => {
        state.list = payload;
    },
};
